import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M29.125 5.25C30.25 5.75 31 6.8125 31 8C31 24 19.1875 32 15.9375 32C12.8125 32 1 24.125 1 8C1 6.8125 1.6875 5.75 2.8125 5.25L14.8125 0.25C15.125 0.125 15.625 0 16 0C16.3125 0 16.8125 0.125 17.125 0.25L29.125 5.25ZM17.5 16.1875C18.625 15.625 19.5 14.4375 19.5 13C19.5 11.125 17.875 9.5 16 9.5C14.0625 9.5 12.5 11.125 12.5 13C12.5 14.4375 13.3125 15.625 14.5 16.1875V20.5C14.5 21.375 15.125 22 16 22C16.8125 22 17.5 21.375 17.5 20.5V16.1875Z'],
  name: 'uiShieldKeyhole',
  oldName: 'fasShieldKeyhole'
} as IconDefinition
